import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  searchQuery: '',
  searchContext: 'Courses',
  coursesResultCount: 0,
  playlistsResultCount: 0,
  videosResultCount: 0,
  viewStyle: 'tile',
  isFiltersCollapsed: false,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
